import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import 'bootstrap-daterangepicker/daterangepicker.css'
import { Chart, BarElement, ArcElement, Legend, Tooltip, CategoryScale, LinearScale } from 'chart.js';
import chartTrendline from "chartjs-plugin-trendline";

Chart.register(BarElement, ArcElement, Legend, Tooltip, CategoryScale, LinearScale, chartTrendline);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
